import React, { useState, useEffect, useRef } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Auth } from 'aws-amplify';
import CloseIcon from '@mui/icons-material/Close';
import { DialogHeader, DialogHeading } from '../Episode/Episode.Styled';
import { AUTHORIZATION_REPORTS_CALOMSACT_URL } from '../../constants';
import { useReactToPrint } from 'react-to-print';
import { PdfGrid } from '../ui/styled';
import { renderDateCell } from '../common/commonUtils/commonUtils';
import { getAuthorizationReportsCalomsactDataGrid } from './AuthorizationReportsCalomsactDataGrid';
import { calomsactPdfDataGrid } from './CalomsactPdfDataGrid';

const AuthorizationReportsCalomsactPdfDialog = (props) => {
  const {
    openAuthorizationReportsCalomsactPdfDialog,
    setOpenAuthorizationReportsCalomsactPdfDialog,
    visibleAuthIds,
  } = props;

  const [user, setUser] = useState(null);
  const [authorizationReportsCalomsac, setAuthorizationReportsCalomsac] =
    useState({
      isLoading: false,
      data: [],
      total: 0,
      page: 1,
      pageSize: 10,
    });

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (visibleAuthIds) {
      if (user?.signInUserSession.accessToken.jwtToken) {
        fetchData();
      }
      getUser().then((userData) => setUser(userData));
    }
  }, [user?.signInUserSession.accessToken.jwtToken, visibleAuthIds]);

  const getUser = () => {
    return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
  };

  const fetchData = async () => {
    setAuthorizationReportsCalomsac((prveState) => ({
      ...prveState,
      isLoading: true,
    }));
    const commonParams = `${AUTHORIZATION_REPORTS_CALOMSACT_URL}${visibleAuthIds}`;
    const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
    const authorizationReportsCalomsacDetails =
      await getAuthorizationReportsCalomsactDataGrid({
        commonParams,
        authorization,
      });
    setAuthorizationReportsCalomsac((prveState) => ({
      ...prveState,
      ...authorizationReportsCalomsacDetails,
    }));
  };

  const groupedData = authorizationReportsCalomsac?.data.filter(g => g.cboName != null && !g.cboName.includes('SLE') && !g.cboName.includes('TH') && !g.cboName.includes('RHWH') && ((g.sapAthAdmDate != null && g.caid == null) || (g.sapAthDchDate != null && g.cdid==null))).reduce((acc, item) => {
    if (acc[item.sapAth_CboID]) {
      acc[item.sapAth_CboID].push(item);
    } else {
      acc[item.sapAth_CboID] = [item];
    }
    return acc;
  }, {});

  const missingProviders = authorizationReportsCalomsac?.data.filter(g => g.cboName == null);
  if (missingProviders.length > 0) {
    //console.log('### missingProviders');
    //console.log(missingProviders);
    var missing = 'Warning!\n'
    missingProviders.forEach((e) => {
      missing += e.prtKey + ' is missing an auth provider\n'
    })
    alert (missing);
  }

  const handleClose = () => {
    setOpenAuthorizationReportsCalomsactPdfDialog(false);
  };

  const columnsData = [
    {
      field: 'sapAthID',
      headerName: 'Auth ID',
      maxSize: 80
    },
    {
      field: 'prtKey',
      headerName: 'Participant',
      flex: 1,
    },
    {
      field: 'epdIcnCDC',
      headerName: 'CDC#',
      maxSize: 80
    },
    {
      field: 'sapAthAdmDate',
      headerName: 'Admit',
      type: 'date',
      renderCell: renderDateCell,
      maxSize: 70
    },
    {
      field: 'caid',
      headerName: '',
      maxSize: 15,
      valueGetter: (value) => {
        return value.row.sapAthAdmDate && !value.value ? String.fromCharCode(10003) : '';
      },
    },
    {
      field: 'sapAthDchDate',
      headerName: 'Discharge',
      type: 'date',
      renderCell: renderDateCell,
      maxSize: 70
    },
    {
      field: 'cdid',
      headerName: '',
      maxSize: 15,
      valueGetter: (value) => {
        return value.row.sapAthDchDate && !value.value ? String.fromCharCode(10003) : '';
      },
    },
    //{
    //  field: 'cboName',
    //  headerName: 'CBP Name',
    //  flex: 1,
    //},
    {
      field: 'sapAthCmt',
      headerName: 'Comment',
      flex: 1,
    },
  ];

  return (
    <Dialog
      fullScreen
      open={openAuthorizationReportsCalomsactPdfDialog}
      onClose={setOpenAuthorizationReportsCalomsactPdfDialog}
    >
      <DialogHeader>
        <DialogHeading variant="h5"></DialogHeading>
        <Box>
          <Button variant="contained" onClick={() => handlePrint()}>
            Print
          </Button>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogHeader>
      <PdfGrid container ref={componentRef}>
        {calomsactPdfDataGrid(
          groupedData,
          authorizationReportsCalomsac,
          columnsData
        )}
      </PdfGrid>
    </Dialog>
  );
};

export default AuthorizationReportsCalomsactPdfDialog;
